import React from 'react';
import { DatePicker, Form, HyperLink, Input } from '@ok/okd';

import { toLocale } from '@common/i18n';
import utils from '@common/utils';

import { useIsMobile } from '../hooks';

import ResumeUploadField from './ResumeUploadField';

const { cdnBaseUrl = '' } = window.okGlobal || {};

const ApplicationFields = ({ app }) => {
  const isNameStacked = useIsMobile(); // stack family/first name vertically on mobile

  // Family + first name; required rule + empty-string validator
  const nameFields = (
    <React.Fragment>
      <Form.Item
        label={toLocale('recruit_form_family_name')}
        name="lastName"
        rules={[
          {
            required: true,
            message: toLocale('recruit_form_family_name_required'),
          },
          () => ({
            validator: (rule, value) =>
              value?.length > 0
                ? Promise.resolve()
                : Promise.reject(toLocale('recruit_form_family_name_required')),
          }),
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={toLocale('recruit_form_first_name')}
        name="firstName"
        rules={[
          {
            required: true,
            message: toLocale('recruit_form_first_name_required'),
          },
          () => ({
            validator: (rule, value) =>
              value?.length > 0
                ? Promise.resolve()
                : Promise.reject(toLocale('recruit_form_first_name_required')),
          }),
        ]}
      >
        <Input />
      </Form.Item>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {isNameStacked ? nameFields : <Form.Line>{nameFields}</Form.Line>}
      <Form.Item
        label={toLocale('recruit_form_birthday')}
        name="birthday"
        rules={[
          {
            required: true,
            message: toLocale('recruit_form_birthday_required'),
          },
          () => ({
            validator: (rule, value) =>
              value
                ? Promise.resolve()
                : Promise.reject(toLocale('recruit_form_birthday_required')),
          }),
        ]}
      >
        <DatePicker format="yyyy-MM-dd" cleanable={false} />
      </Form.Item>
      <Form.Item
        label={toLocale('recruit_form_email')}
        name="email"
        rules={[
          {
            required: true,
            message: toLocale('recruit_form_email_required'),
          },
          () => ({
            validator: (rule, value) => {
              if (value?.length > 0) {
                return utils.checkEmail(value)
                  ? Promise.resolve()
                  : Promise.reject(toLocale('recruit_form_email_invalid'));
              }
              return Promise.reject(toLocale('recruit_form_email_required'));
            },
          }),
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={toLocale('recruit_form_location')}
        name="location"
        rules={[
          {
            required: true,
            message: toLocale('recruit_form_location_required'),
          },
          () => ({
            validator: (rule, value) =>
              value?.length > 0
                ? Promise.resolve()
                : Promise.reject(toLocale('recruit_form_location_required')),
          }),
        ]}
      >
        <Input />
      </Form.Item>
      <ResumeUploadField app={app} />
      <Form.Item
        label={toLocale('recruit_form_salary')}
        name="expectedAnnualSalary"
        rules={[
          () => ({
            validator: (rule, value) =>
              !value || /^\d+$/.test(value)
                ? Promise.resolve()
                : Promise.reject(toLocale('recruit_form_digits_only')),
          }),
        ]}
      >
        <Input suffix={toLocale('recruit_form_jpy')} />
      </Form.Item>
      <Form.Item label={toLocale('recruit_form_desired')} name="comment">
        {/* Single child so okd can manage the TextArea value */}
        <Input.TextArea className="recruit-submit__textarea" />
      </Form.Item>
      <div className="recruit-submit__privacy">
        <HyperLink
          className="recruit-submit__privacy-link"
          target="_blank"
          href={`${cdnBaseUrl}/cdn/assets/pdf/recruit/recruit_description.pdf`}
        >
          {toLocale('recruit_form_privacy')}
        </HyperLink>
      </div>
    </React.Fragment>
  );
};

export default ApplicationFields;
